<figure
  class="preview-container"
  [style.background-image]="
    selectedEmplacement !== null
      ? 'url(' + baseImgURL + selectedEmplacement.picture.path + ')'
      : ''
  "></figure>
